export const PHONE_NUMBER_KEYS = {
  CUSTOMER_CARE: 'Customer care phone number',
  SHOP_ADVISOR: 'shopAdvisor.phoneNumber',
} as const;
